import React from 'react';
import { Link } from 'react-router-dom';
import { Popper } from 'react-popper';
import * as olProj from 'ol/proj';

const initAnimationSpeed = 1;
const widthStyle = {width:"350px"};

class ResultAside extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.linkItems = props.linkItems //link, btn, text
    this.onResetAnimationClick = () => { props.onResetAnimationClick(); this.setState({ actualTrajectoryPointNo: 0 }); }
    this.actualPointCallback = this.actualPointCallback.bind(this);
    this.showAnimationClick = this.showAnimationClick.bind(this);
    this.handleClick = this.handleClick.bind(this);

    this.popper = null;
    this.popperButton = null;

    this.state = {
      loaded: props.loaded,
      points: props.points,
      actualTrajectoryPointNo: props.actualTrajectoryPointNo,
      showAnimationSpeed: false,
      animationSpeed: initAnimationSpeed
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.loaded !== nextProps.loaded)
      this.setState({ loaded: nextProps.loaded, points: nextProps.points });
    else if (this.state.actualTrajectoryPointNo !== nextProps.actualTrajectoryPointNo)
      this.setState({ actualTrajectoryPointNo: nextProps.actualTrajectoryPointNo });
  }

  actualPointCallback(actualTrajectoryPointNo) {
    this.setState({
      actualTrajectoryPointNo: actualTrajectoryPointNo,
    });

    let selected = document.getElementById('selected');
    if (selected)
      selected.scrollIntoView();
  }

  showAnimationClick() {
    let showAnimation = this.state?.showAnimationSpeed;
    this.setState({ showAnimationSpeed: !showAnimation });
  }

  handleClick (e) {
    if (this?.popper === e.target || this?.popperButton === e.target) {
      // inside click
      return;
    }
    this.setState({
      showAnimationSpeed: false,
    });
  };

  getStartCoordinatesInDegrees() {
    let result = {Lat:0, Lon: 0}
    let startPointDegrees = this.props?.startPoint ? olProj.transform([this.props.startPoint.Lon, this.props.startPoint.Lat], 'EPSG:3857', 'EPSG:4326') : null;
    result.Lat = Array.isArray(startPointDegrees) && startPointDegrees.length === 2? (startPointDegrees[1]).toFixed(7): null;
    result.Lon = Array.isArray(startPointDegrees) && startPointDegrees.length === 2? (startPointDegrees[0]).toFixed(7): null;
    return result;
  }

  render() {
    let startCoordinates = this.getStartCoordinatesInDegrees()

    return <>
      {/* [BLOCK] Aside */}
      <div key={"asideBlock"} className="aside-block" onClick={this.handleClick}>
        <div className="aside-content-container">
          <div className="aside-content">
            <h1 className="h2-size heading">
              Result
            </h1>
            <div>
              <button type="button" className="btn" onClick={() => { this?.props?.setAnimationSpeed && this.props.setAnimationSpeed(this.state?.animationSpeed); this?.props?.onPlayAnimationClick && this.props.onPlayAnimationClick(); }}><i className="icon icon-play pr-2" />Play animation</button>
              <button type="button" className="btn btn-secondary btn-icon" onClick={() => {this.props?.onAnimationStopClick && this.props.onAnimationStopClick()}}><i className="icon icon-pause" /></button>
              <button type="button" className="btn btn-secondary btn-icon" onClick={() => {this.props?.onResetAnimationClick && this.props.onResetAnimationClick()}}><i className="icon icon-redo" /></button>
              <button 
                type="button" 
                className="btn btn-secondary btn-icon" 
                id="animationSetting" 
                data-toggle="dropdown" 
                aria-expanded="false" 
                onClick={this.showAnimationClick}
                ref={instance => { this.popperButton = instance; }}
              >
                <i className="icon icon-sliders-h"></i>
              </button>
              <div style={{position:'relative'}}>
                {this.state.showAnimationSpeed && 
                <Popper anchorEl={this.state.showAnimationSpeed} placement="right">
                  {({ ref, style, placement, arrowProps }) => (
                    <div className = "dropdown-menu px-3 py-2 show" ref={ref} style={{ ...style, ...widthStyle }}>
                      <div className="form-group"><label htmlFor="precision">Animation speed</label>
                      <input 
                        className="form-control-range" 
                        id="precision" 
                        type="range" 
                        value = {this.state.animationSpeed} 
                        min={0.25} 
                        max={3} 
                        step={0.25}
                        onChange ={
                          (e) => {                            
                            if (this.props?.setAnimationSpeed)
                              this.props.setAnimationSpeed(e.target.value);
                            this.setState({animationSpeed:e.target.value});
                          }                          
                        }  
                        ref={instance => { this.popper = instance; }}                    
                      />
                      <div className="range-aprox-values"><span>Low</span><span className="label text-fade-color">(<output id="precisionValue">{this.state.animationSpeed}</output>x)</span><span>High</span></div>
                      </div>
                    </div>
                  )}
                </Popper>}
              </div>
            </div>
          </div>
        </div>
        <div className="aside-content-container flex-grow-0 flex-shrink-0 py-3">
          <div className="aside-content d-flex align-items-center">
            <div className='startpoint-icon mr-auto'>
              <img src='./icon-start.png' alt='Start-point icon'/>
            </div>
            <div className='info-box mr-auto'>
              <h6 className='text-fade-color mb-0'>Latitude:</h6>
              <span className='text-fade-color'>{startCoordinates.Lat}</span> 
            </div>
            <div className='info-box mr-auto'>
              <h6 className='text-fade-color mb-0'>Longitude:</h6>
              <span className='text-fade-color'>{startCoordinates.Lon}</span>
            </div>
          </div>
        </div>
        <div className="aside-content-container flex-basis-8 flex-grow-1 flex-shrink-0 scrollable">
          <div className="aside-content">
            <table ref={this.setRef}>
              <thead>
                <tr>
                  <th />
                  <th className="subheading text-center">North</th>
                  <th className="subheading text-center">East</th>
                  <th className="subheading text-center">Direction</th>
                </tr>
              </thead>
              <tbody id="aside-tbody">
                {this.state.loaded
                  && this.state.points
                  && this.state.points.map((item, index) =>
                    <tr key={index}
                      className={this.state.actualTrajectoryPointNo === index ? "selected" : ""}
                      id={this.state.actualTrajectoryPointNo === index ? "selected" : ""}
                      onClick={() => {
                        if (this.props.clickPointCallback) {
                          //
                          this.props.clickPointCallback(index + 1);
                          this.setState({ actualTrajectoryPointNo: index })
                        }
                      }
                    }
                    >
                      <td className="text-fade-color font-weight-bold text-right">{index}</td>
                      <td className="text-right">{item[1]} m</td>
                      <td className="text-right">{item[0]} m</td>
                      {item[2] === 0 && <td className="text-center"><i className="icon icon-redo" /></td>}
                      {item[2] === 1 && <td className="text-center"><i className="icon icon-undo" /></td>}
                      {item[2] === -1 && <td className="text-center"><i className="icon icon-arrow-up" /></td>}
                    </tr>
                  )}
              </tbody>
            </table>
          </div>
        </div>
        <div className="aside-content-container py-2">
          <div className="aside-content d-grid grid-autofill-3 grid-gap-2">
            {this.linkItems
              && this.linkItems.map((item, index) =>
                <Link to={`${item.link}`} className="card" key={"link" + index}>
                  <img src={`${item.img}`} className="card-img-top" alt={`${item.alt}`} style={{ width: '100%', height: '6rem' }} />
                  <div className="card-body p-2">
                    <h5 className="card-title heading hover-highlight text-center mb-0">{`${item.name}`} </h5>
                  </div>
                </Link>
              )}
          </div>
        </div>
      </div>
    </>
  }
};

export default ResultAside;